import React, { useState, useEffect, useRef } from "react";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import JoditEditor from "jodit-react";
import backarrow from "../../../../components/Images/backarrow.svg";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";

function Email_Setting(props) {

  const [setting, setSetting] = useState({
    // Advertisement_Setting
    ads_on_videos: "",
    cpc_advertiser: "",
    featured_pre_ad: "",
    featured_mid_ad: "",
    featured_post_ad: "",
    cpc_admin: "",
    cpv_advertiser: "",
    cpv_admin: "",
    default_ads_url: "",
    ads_play_unlimited_period: "",
    ads_on_livestream: "",
    ads_on_audios: "",
    ads_on_episodes: "",
    // Advertisement_Setting
    //coupon code
    new_subscriber_coupon: "",
    discount_percentage: "",
    coupon_code: "",
    //coupon code
    //email setting
    google_oauth_key: "",
    coupon_status: "",
    google_tracking_id: "",
    system_email: "",
    system_phone_number: "",
    system_address: "",
    google_analytics_link: "",
    //email setting
    //login setting
    notification_icon: "",
    notification_key: "",
    login_text: "",
    login_content: "",
    signature: "",
    //login setting
    //geo fencing
    id: "",
    geofencing: "",
    geofencing_status: "",
    //geo fencing
    // payout setting
    payout_method: "",
    //payout setting
    //ppv setting
    ppv_status: "",
    ppv_rent: "",
    ppv_price: "",
    ppv_hours: "",
    ios_product_id: "",
    ios_plan_price: "",
    expiry_time_started: "",
    expiry_day_notstarted: "",
    expiry_hours_notstarted: "",
    expiry_min_notstarted: "",
    PPV_Individual_Contents: "",
    //ppv setting
    // capcha setting
    captcha_site_key: "",
    captcha_secret_key: "",
    captcha: "",
    //capcha setting
    //registration settings
    free_registration: "",
    activation_email: "",
    premium_upgrade: "",
    access_free: "",
    enable_landing_page: "",
    //registration settings
    //search settings
    search_title_status: "",
    search_category_status: "",
    search_tags_status: "",
    search_description_status: "",
    search_details_status: "",
    //search settings
    //series settings
    series_season: "",
    series_networks_status: "",
    //series settings
    //site settings
    website_name: "",
    website_description: "",
    logo_height: "",
    logo_width: "",
    login_content: "",
    favicon: "",
    logo: "",
    //site settings
    //social network settings
    facebook_page_id: "",
    google_page_id: "",
    twitter_page_id: "",
    instagram_page_id: "",
    linkedin_page_id: "",
    whatsapp_page_id: "",
    skype_page_id: "",
    youtube_page_id: "",
    email_page_id: "",
    tiktok_page_id: "",
    //social network settings
    //video settings
    videos_per_page: "",
    posts_per_page: "",
    show_description: "",
    show_Links_and_details: "",
    show_genre: "",
    show_languages: "",
    show_subtitle: "",
    show_artist: "",
    show_recommended_videos: "",
    show_views: "",
    videos_expiry_status: "",
    epg_status: "",
    //video settings
    earn_amount: "",
    video_clip_enable: "",
    enable_ppv_rent: "",
  });

  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const handleChangeFirst = (e) => {
    setSetting({ ...setting, system_address: e });
    // console.log(e, "onchnageddddd");
  };

  useEffect(async () => {
    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/setting/index`, {
        headers: headers,
      })
      .then((response) => {
        var setting = response?.data?.setting;
        setSetting(setting);
      })
      .catch((error) => console.log(error));
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (e.target.type === "number" && Number(value) < 0) return;
    setSetting((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));

    setValidationMessagesystem_email("");
    setIsValidationHiddensystem_email(true);
    setSetting({ ...setting, [e.target.name]: e.target.value });

  };

  const handleInputenable = (e) => {
    if (e.target.checked === true) {
      setSetting({ ...setting, [e.target.name]: 1 });
    } else {
      setSetting({ ...setting, [e.target.name]: 0 });
    }
  };

  const [validationMessagesystem_email, setValidationMessagesystem_email] =
    useState("");
  const [isValidationHiddensystem_email, setIsValidationHiddensystem_email] =
    useState(true);

  const system_emailInputRef = useRef(null);

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  async function handleUpdate() {
    let focusInputRef = null;
    const trimmedSystemEmail = setting?.system_email?.trim();

    if (trimmedSystemEmail === "") {
      setValidationMessagesystem_email("Email cannot be empty.");
      setIsValidationHiddensystem_email(false);
      focusInputRef = system_emailInputRef;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedSystemEmail)) {
      setValidationMessagesystem_email("Email format is incorrect.");
      setIsValidationHiddensystem_email(false);
      focusInputRef = system_emailInputRef;
    }

    if (focusInputRef) {
      focusInputRef?.current?.focus();
      return;
    }

    const enable_ppv_rent = Number.isNaN(parseInt(setting?.enable_ppv_rent, 10)) ? 0 : parseInt(setting?.enable_ppv_rent, 10);

    // advertisement setting
    const ads_on_videos = Number.isNaN(parseInt(setting?.ads_on_videos, 10)) ? 0 : parseInt(setting?.ads_on_videos, 10);
    const ads_play_unlimited_period = Number.isNaN(parseInt(setting?.ads_play_unlimited_period, 10)) ? 0 : parseInt(setting?.ads_play_unlimited_period, 10);
    const ads_on_livestream = Number.isNaN(parseInt(setting?.ads_on_livestream, 10)) ? 0 : parseInt(setting?.ads_on_livestream, 10);
    const ads_on_audios = Number.isNaN(parseInt(setting?.ads_on_audios, 10)) ? 0 : parseInt(setting?.ads_on_audios, 10);
    const ads_on_episodes = Number.isNaN(parseInt(setting?.ads_on_episodes, 10)) ? 0 : parseInt(setting?.ads_on_episodes, 10);

    //coupon setting      
    const coupon_code = Number.isNaN(parseInt(setting?.coupon_code, 10)) ? 0 : parseInt(setting?.coupon_code, 10);


    //payout settings   
    const payout_method = Number.isNaN(parseInt(setting?.payout_method, 10)) ? 0 : parseInt(setting?.payout_method, 10);


    //registration settings
    const free_registration = Number.isNaN(parseInt(setting?.free_registration, 10)) ? 0 : parseInt(setting?.free_registration, 10);


    //search settings
    const search_title_status = Number.isNaN(parseInt(setting?.search_title_status, 10)) ? 0 : parseInt(setting?.search_title_status, 10);
    const search_category_status = Number.isNaN(parseInt(setting?.search_category_status, 10)) ? 0 : parseInt(setting?.search_category_status, 10);
    const search_tags_status = Number.isNaN(parseInt(setting?.search_tags_status, 10)) ? 0 : parseInt(setting?.search_tags_status, 10);
    const search_description_status = Number.isNaN(parseInt(setting?.search_description_status, 10)) ? 0 : parseInt(setting?.search_description_status, 10);
    const search_details_status = Number.isNaN(parseInt(setting?.search_details_status, 10)) ? 0 : parseInt(setting?.search_details_status, 10);


    //serires settings
    const series_networks_status = Number.isNaN(parseInt(setting?.series_networks_status, 10)) ? 0 : parseInt(setting?.series_networks_status, 10);

    // video settings 
    const videos_expiry_status = Number.isNaN(parseInt(setting?.videos_expiry_status, 10)) ? 0 : parseInt(setting?.videos_expiry_status, 10);
    const videos_per_page = Number.isNaN(parseInt(setting?.videos_per_page, 10)) ? 0 : parseInt(setting?.videos_per_page, 10);
    const epg_status = Number.isNaN(parseInt(setting?.epg_status, 10)) ? 0 : parseInt(setting?.epg_status, 10);
    const show_genre = Number.isNaN(parseInt(setting?.show_genre, 10)) ? 0 : parseInt(setting?.show_genre, 10);
    const show_languages = Number.isNaN(parseInt(setting?.show_languages, 10)) ? 0 : parseInt(setting?.show_languages, 10);
    const show_subtitle = Number.isNaN(parseInt(setting?.show_subtitle, 10)) ? 0 : parseInt(setting?.show_subtitle, 10);
    const show_artist = Number.isNaN(parseInt(setting?.show_artist, 10)) ? 0 : parseInt(setting?.show_artist, 10);
    const show_recommended_videos = Number.isNaN(parseInt(setting?.show_recommended_videos, 10)) ? 0 : parseInt(setting?.show_recommended_videos, 10);
    const show_views = Number.isNaN(parseInt(setting?.show_views, 10)) ? 0 : parseInt(setting?.show_views, 10);
    const show_Links_and_details = Number.isNaN(parseInt(setting?.show_Links_and_details, 10)) ? 0 : parseInt(setting?.show_Links_and_details, 10);
    const show_description = Number.isNaN(parseInt(setting?.show_description, 10)) ? 0 : parseInt(setting?.show_description, 10);

    const editInputvalue = {

      // advertisement setting
      ads_on_videos: ads_on_videos,
      default_ads_url: setting?.default_ads_url,
      featured_pre_ad: setting?.featured_pre_ad,
      featured_mid_ad: setting?.featured_mid_ad,
      featured_post_ad: setting?.featured_post_ad,
      cpv_admin: setting?.cpv_admin,
      cpv_advertiser: setting?.cpv_advertiser,
      cpc_admin: setting?.cpc_admin,
      cpc_advertiser: setting?.cpc_advertiser,
      ads_play_unlimited_period: ads_play_unlimited_period,
      ads_on_livestream: ads_on_livestream,
      ads_on_audios: ads_on_audios,
      ads_on_episodes: ads_on_episodes,

      //coupon setting      
      discount_percentage: setting?.discount_percentage,
      coupon_code: coupon_code,
      new_subscriber_coupon: setting?.new_subscriber_coupon,

      //email settings
      coupon_status: setting?.coupon_status,
      google_tracking_id: setting?.google_tracking_id,
      google_oauth_key: setting?.google_oauth_key,
      system_email: setting?.system_email,
      system_phone_number: setting?.system_phone_number,
      system_address: setting?.system_address,
      google_analytics_link: setting?.google_analytics_link,

      //login settings      
      login_text: setting?.login_text,
      signature: setting?.signature,
      login_content: setting?.login_content,
      notification_key: setting?.notification_key,

      //payout setting
      payout_method: payout_method,

      //ppv settings
      ppv_status: setting?.ppv_status,
      PPV_Individual_Contents: setting?.PPV_Individual_Contents,
      ppv_price: setting?.ppv_price,
      ppv_hours: setting?.ppv_hours,
      ios_plan_price: setting?.ios_plan_price,
      ios_product_id: setting?.ios_product_id,
      expiry_time_started: setting?.expiry_time_started,
      expiry_day_notstarted: setting?.expiry_day_notstarted,
      expiry_hours_notstarted: setting?.expiry_hours_notstarted,
      expiry_min_notstarted: setting?.expiry_min_notstarted,
      enable_ppv_rent_live: setting?.enable_ppv_rent_live,
      enable_ppv_rent_series: setting?.enable_ppv_rent_series,
      enable_ppv_rent_audio: setting?.enable_ppv_rent_audio,


      //registration settings
      enable_landing_page: setting?.enable_landing_page,
      free_registration: free_registration,
      activation_email: setting?.activation_email,
      premium_upgrade: setting?.premium_upgrade,
      access_free: setting?.access_free,

      //search settings
      search_title_status: search_title_status,
      search_category_status: search_category_status,
      search_tags_status: search_tags_status,
      search_description_status: search_description_status,
      search_details_status: search_details_status,

      //serires settings
      series_season: setting?.series_season,
      series_networks_status: series_networks_status,

      //site settings
      website_name: setting?.website_name,
      website_description: setting?.website_description,
      logo: setting?.logo,
      logo_height: setting?.logo_height,
      logo_width: setting?.logo_width,
      favicon: setting?.favicon,

      //social network settings
      facebook_page_id: setting?.facebook_page_id,
      google_page_id: setting?.google_page_id,
      twitter_page_id: setting?.twitter_page_id,
      instagram_page_id: setting?.instagram_page_id,
      linkedin_page_id: setting?.linkedin_page_id,
      whatsapp_page_id: setting?.whatsapp_page_id,
      skype_page_id: setting?.skype_page_id,
      youtube_page_id: setting?.youtube_page_id,
      tiktok_page_id: setting?.tiktok_page_id,
      email_page_id: setting?.email_page_id,

      //default_time_zone
      default_time_zone: setting?.default_time_zone,

      // video settings 
      videos_per_page: videos_per_page,
      posts_per_page: setting?.posts_per_page,
      show_description: show_description,
      show_Links_and_details: show_Links_and_details,
      show_genre: show_genre,
      show_languages: show_languages,
      show_subtitle: show_subtitle,
      show_artist: show_artist,
      show_recommended_videos: show_recommended_videos,
      show_views: show_views,
      videos_expiry_status: videos_expiry_status,
      epg_status: epg_status,

      epg_status: enable_ppv_rent,

      earn_amount: setting?.earn_amount ? parseInt(setting?.earn_amount, 10) : 0,
      video_clip_enable: setting?.video_clip_enable ? parseInt(setting?.video_clip_enable, 10) : 0,

    };


    let firstApiStatus = false;
    let resultapi = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/setting/store`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res?.json();

      if (resjson?.status === true) {
        firstApiStatus = true;

        resultapi = resjson;

        // secondApiStatus = true;
      }
    } catch (error) {
      console.error("Error:", error);
    }

    if (firstApiStatus) {
      setValidationMessagesystem_email("");
      props?.setApiresponsealert(resultapi);
      props?.setShowalert(true);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      if (resultapi === false) {
        var resultError = resultapi;

        // console.log(resultError);
        props?.setApiresponsealert(resultError);
        props?.setShowalert(true);
        setIsValidationHiddensystem_email(false);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  }

  return (
    <>
      <AdminBackNavigation path="/settings" text="Back" />
      <div className=" m-0 p-0">
        <div className="">
          <section className="container-fluid">
            <div className="col-lg-12 row py-3">
              {/* <Link to="/settings" className="backarrow" >
                <img src={backarrow} alt="flogo" width={20} height={20} />{" "}
                <span> Back</span>
              </Link> */}
              <div className="col-6 col-sm-6 col-lg-6">
                <h4 className="admin-title mb-0 theme-text-color text-md-start">System Settings</h4>
              </div>
              <div className="col-6 col-sm-6 col-lg-6">
                <div className="text-end">
                  <button onClick={handleUpdate} className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3">
                    Update
                  </button>
                </div>
              </div>
            </div>

            <div>
              {showOverlay && <Response_Processing></Response_Processing>}
            </div>

            <div className="row col-lg-12 ">
              <div className=" col-sm-6 col-md-6 col-lg-6 ">
                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Create Email</h5>
                  <div className=" text-start">
                    <p className="mandatorySimple theme-text-color mt-0 admin-input-title d-block position-relative">System Email</p>
                    <span className="theme-text-color opacity-75 admin-input-description">
                      Email address to be used to send system email
                    </span>
                    <div className="mt-2">
                      <input
                        type="text"
                        // id="system_email"
                        name="system_email"
                        className="rs-input form-control-lg custom-input  custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3"
                        // id="system_email"
                        onChange={handleInput}
                        value={setting?.system_email}
                        ref={system_emailInputRef}
                      />
                    </div>
                    <span className="errorred">
                      {!isValidationHiddensystem_email && (
                        <p>{validationMessagesystem_email}</p>
                      )}
                    </span>
                  </div>
                  <div className="mt-2 text-start">
                    <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Google Analytics Tracking ID</p>
                    <span className="theme-text-color opacity-75 admin-input-description">
                      Google Analytics Tracking ID (ex. UA-12345678-9)
                    </span>
                    <div className="mt-2">
                      <input
                        type="text"
                        // id="google_tracking_id"
                        name="google_tracking_id"
                        value={setting?.google_tracking_id}
                        className="rs-input form-control-lg custom-input  custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3"
                        onChange={handleInput}
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="mt-2 text-start">
                    <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Google Oauth Client ID Key</p>
                    <span className="theme-text-color opacity-75 admin-input-description">
                      Google Analytics API Integration (This will integrate with
                      your dashboard analytics)
                    </span>
                    <div className="mt-2">
                      <input
                        type="text"
                        // id="ppv_price"
                        name="google_oauth_key"
                        value={setting?.google_oauth_key}
                        className="rs-input form-control-lg custom-input  custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3"
                        onChange={handleInput}
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="mt-2 text-start">
                    <p className="theme-text-color mt-0 admin-input-title d-block position-relative">Google Analytics Link</p>
                    <div className="mt-2">
                      <input
                        type="text"
                        // id="ppv_price"
                        name="google_analytics_link"
                        value={setting?.google_analytics_link}
                        className="rs-input form-control-lg custom-input  custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3"
                        onChange={handleInput}
                        placeholder=""
                      />
                    </div>
                  </div>
                </div>

                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Status Settings</h5>
                  <div className="row">
                    <div className="col-9 col-sm-9 col-lg-9">
                      <p className="p2">Enable Email Coupon</p>
                    </div>
                    <div className="col-3 col-sm-3 col-lg-3 text-end">
                      {/* <label className="switch">
                        <input
                          name="coupon_status"
                          id="coupon_status"
                          onChange={handleInputenable}
                          className="rs-input"
                          defaultChecked={
                            setting?.coupon_status == 1 ? true : false
                          }
                          checked={setting?.coupon_status == 1 ? true : false}
                          type="checkbox"
                        />
                        <span
                          className="slider round"
                          name="coupon_status"
                          id="coupon_status"
                          onChange={handleInputenable}
                          value={setting?.coupon_status == 1 ? "1" : "0"}
                        ></span>
                      </label> */}
                      <AdminSwitch name="coupon_status" checked={setting?.coupon_status == 1} onChange={(e) => handleInputenable(e, setting)} id={setting?.coupon_status} />
                    </div>
                  </div>
                </div>

                <div className="text-start mb-3">
                  <button onClick={handleUpdate} className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3">
                    Update
                  </button>
                </div>
              </div>

              {/* Second Part of Section  */}

              <div className=" col-sm-6 col-md-6 col-lg-6">
                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Email Details</h5>
                  <div className="text-start">
                    <p className="theme-text-color mt-0 admin-input-title d-block position-relative">System Phone Number</p>
                    <span className="theme-text-color opacity-75 admin-input-description">
                      Enter You're System Phone Number
                    </span>
                    <div className="mt-2">
                      <input
                        type="number"
                        // id="system_phone_number"
                        name="system_phone_number"
                        value={setting?.system_phone_number}
                        className="rs-input form-control-lg custom-input  custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3"
                        onChange={handleInput}
                        min="0"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className=" mt-2 text-start">
                    <p className="theme-text-color mt-0 admin-input-title d-block position-relative">System Address</p>
                    <span className="theme-text-color opacity-75 admin-input-description">
                      Enter You're System Address
                    </span>

                    <div className="mt-2">
                      <JoditEditor
                        className="rs-input"
                        value={setting?.system_address}
                        onChange={(e) => {
                          handleChangeFirst(e);
                        }}
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        </div>
      </div>

    </>
  );
}

export default Email_Setting;
